import {AfterViewInit, Component, Input, OnDestroy, QueryList, ViewChildren,} from "@angular/core";
import {MatTableDataSource} from '@angular/material/table';
import {RootScopeService} from "@tva/ng-migration/core/services/rootscope/rootscope.service";
import {PathwayComponent} from "./pathway/pathway.component";
import {Pathway, PathwaySchoolCourse} from "@tva/ng-migration/cre-tracking/models";
import {LocationService} from "@tva/ng-migration/core/services/location/location.service";
import {UnsavedChangesService} from "@tva/ng-migration/shared/services/unsavedChanges.service";
import {ReplaySubject} from "rxjs";
import {distinctUntilChanged, takeUntil} from "rxjs/operators";
import {UIBaseComponent} from "@tva/ng-migration/uicomponents/base/ui-base.component";
import {PathwayConstants} from "@tva/ng-migration/cre-tracking/components/search/cre-management-search-results/pathway/pathway.constants";


@Component({
    selector: "app-cre-management-search-results",
    templateUrl: "./cre-management-search-results.component.html",
    styleUrls: ["./cre-management-search-results.component.scss"],
})
export class CreManagementSearchResultsComponent extends UIBaseComponent implements AfterViewInit, OnDestroy{
    searchedFilters: any = {};
    dataSource: MatTableDataSource<any>;
    selectedPathway: PathwayComponent;
    promptOnUrlChange;
    $modification = new ReplaySubject<boolean>();

    @Input() pathways;
    @Input() school;
    @Input() schoolCourses: PathwaySchoolCourse[];

    @ViewChildren(PathwayComponent) pathwaysList: QueryList<PathwayComponent>;

    constructor(public rootScope: RootScopeService, public location: LocationService, private unsavedChanges: UnsavedChangesService) {
        super();
    }

    ngAfterViewInit() {
        this.loadModifications();
        this.unsavedChanges.setMessage(PathwayConstants.unsaved_message);
    }

    ngOnDestroy() {
        this.$modification.complete();
        this.unsavedChanges.resetMessage();
    }

    wasModified(value: boolean) {
        this.$modification.next(value);
    }

    areButtonsEnabled(): boolean {
        return !this.unsavedChanges.hasUnsavedChanges();
    }

    loadModifications(){
        this.$modification.pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((wasModified)=>{
            if (wasModified) {
                this.unsavedChanges.startChanges();
                this.promptOnUrlChange = this.rootScope.onChangeStart( (event, next) => {
                    event.preventDefault();
                    this.unsavedChanges.verify(()=> {
                        this.promptOnUrlChange();
                        this.location.url(next.url);
                    })
                });
            } else {
                if (this.promptOnUrlChange)
                    this.promptOnUrlChange();
                this.unsavedChanges.saveChanges();
            }
        });
    }

    save(): void{
        this.selectedPathway?.save(this.school.schoolId);
    }

    reset(): void {
        this.selectedPathway?.reset();
        if (this.promptOnUrlChange){
            this.promptOnUrlChange();
        }
    }

    wasSelected(pathway: Pathway) {
        const pathwayComponent = this.pathwaysList.find(pathwayComponent => pathwayComponent.pathway === pathway);
        if (!this.selectedPathway){
            this.selectedPathway = pathwayComponent;
            this.selectedPathway.open();
        } else {
            this.unsavedChanges.verify(()=>{
                this.updateSelectedPathwayComponent(pathway, pathwayComponent);
            })
        }
    }

    private updateSelectedPathwayComponent(pathway: Pathway, pathwayComponent: PathwayComponent): void{
        if (this.selectedPathway.pathway === pathway){
            this.selectedPathway.close();
            this.selectedPathway = null;
        } else {
            this.selectedPathway.close();
            this.selectedPathway = pathwayComponent;
            this.selectedPathway.open();
        }
    }

}
